import Tooltip from 'controllers/tooltip_controller'

export default class Popover extends Tooltip {
  static targets = ["button", "content"]

  initialize() {
    // set up this element like a tooltip, then just re-use the tooltip controller setup
    if (this.hasContentTarget && this.hasButtonTarget) {
      this.content = this.contentTarget
      this.buttonElement = this.buttonTarget
    } else {
      this.content = this.element.dataset.content
    }
    this.trigger = "click"
    this.theme = this.element.dataset.theme || "default-popover"
    this.interactive = true
    super.initialize()
  }
}
